<div class="bars">
  @for (bar of bars; track bar) {
    <div class="bar-container"
      >
      <div [className]="'bar bg-' + bar.color"
        [style.height]="bar.percent + '%'">
        @if (bar.icon) {
          <img
            [src]="ASSET_URL + '/innogy-icons/Negative/' + bar.icon"/>
        }
      </div>
    </div>
  }
</div>
